import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { LoginModel } from 'src/app/models/login.model';
import { CustomCostPopupComponent } from 'src/app/modules/analytics/analytics-page/custom-cost-popup/custom-cost-popup.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-custom-cost-cell-renderer',
  templateUrl: './custom-cost-cell-renderer.component.html',
  styleUrls: ['./custom-cost-cell-renderer.component.scss']
})
export class CustomCostCellRendererComponent implements OnInit,OnDestroy {
  params;
  customCost: any=[];
  isPeroid: boolean;
  userInfo: LoginModel;
  private destroy$ = new Subject<void>();
  constructor(private dialog: MatDialog,
    private gridActionsService: GridActionsService,
    private authService: AuthService,) {
      this.authService.userInfo$.pipe(takeUntil(this.destroy$)).subscribe((res) => this.userInfo = res);
     }

  ngOnInit(): void {
  }

  agInit(params:any){
    this.params = params;
    this.customCost= this.params?.data?.CustomCost?.costs;
    if(this.customCost?.length){
      this.customCost.filter((ele)=>{
        if(ele.qty){
          this.isPeroid=false;
        } else{
          this.isPeroid=true;
        }
      })
    }
  }
  addCustomCost(){
    this.dialog.open(CustomCostPopupComponent, {
      width: "385px",
      data: {
        title: 'Add Custom Cost',
        isPeroid: this.isPeroid,
        accountSkuId: this.params.data.AccountSkuId
      }
    }).afterClosed()
    .subscribe((e) => {
      if (e==="Confirm"){
        this.params.api.refreshServerSide({ purge: true });
        this.openSideBar();
      }
    });
  }

  openSideBar(){
    this.gridActionsService.openSidePanel("costToolPanel");
    const toolpanelComponent = this.params.api.getToolPanelInstance('costToolPanel');
    if (toolpanelComponent) {
      toolpanelComponent.refresh(null);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
